// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"315":"ebcd77fe","453":"54c4d353"}[chunkId] + ".chunk.js";
};